// // System
// import { useSnackbar } from 'notistack';
// import { Box } from '@mui/material';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// // Components
// import { LoadingScreen } from '@Components/shared/loaders/LoadingScreen';
// // Redux
// import { useRoundDrawer } from '@Modal/hooks/rounds/useRoundDrawer';
// // Graphql
// import { usePaginatedAviatorPlayerIdsRoundsQuery } from '@Src/generated.graphql';
// // Styles
// import Styles from './PlayerIdContainer.module.scss';

// export const PlayerIds = () => {
//   const { enqueueSnackbar } = useSnackbar();
//   const { selectedRoundData } = useRoundDrawer();
//   const { data, loading } = usePaginatedAviatorPlayerIdsRoundsQuery({
//     variables: { filter: { roundId: selectedRoundData?._id } },
//   });
//   const players = data?.paginatedAviatorPlayerIdsRounds?.docs;

//   const handleCopy = (string: string) => {
//     if (string) {
//       console.log(string);
//       navigator.clipboard.writeText(string).then(() => {
//         enqueueSnackbar('Copied successfully', {
//           autoHideDuration: 2000,
//           anchorOrigin: {
//             vertical: 'bottom',
//             horizontal: 'right',
//           },
//         });
//       });
//     }
//   };

//   if (loading) return <LoadingScreen />;

//   return (
//     <Box className={Styles.PlayerIds}>
//       {players && players.length > 0
//         ? players?.map(({ playerId, username }, index) => (
//             <Box key={index} className={Styles.PlayerId}>
//               <Box className={Styles.PlayerIdContainer} key={index}>
//                 <Box className={Styles.IdContainer}>
//                   {playerId}
//                   <ContentCopyIcon
//                     sx={{ width: '20px', cursor: 'pointer' }}
//                     onClick={() => handleCopy(playerId)}
//                   />
//                 </Box>
//                 <Box className={Styles.IdContainer}>
//                   {username}
//                   <ContentCopyIcon
//                     sx={{ width: '20px', cursor: 'pointer' }}
//                     onClick={() => handleCopy(username)}
//                   />
//                 </Box>
//               </Box>
//             </Box>
//           ))
//         : 'No Player IDs'}
//     </Box>
//   );
// };

export const PlayerIds = () => {
  return <div>Mines Does not have player IDs</div>;
};
